import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

const UserBadge = () => {
  const [fullName, setFullName] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        if (payload.name && payload.surname) {
          setFullName(`${payload.name} ${payload.surname}`);
        }
      } catch (e) {
        console.error("Error decoding token", e);
      }
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleEditProfile = () => {
    navigate("/profile");
    setIsOpen(false);
  };

  const handleChangePassword = () => {
    navigate("/change-password");
    setIsOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };

  const handleDeleteAccount = async () => {
    setIsOpen(false);
    const confirmed = window.confirm(
      "Are you sure you want to delete your account? This action cannot be undone."
    );
    if (!confirmed) return;

    const token = localStorage.getItem("authToken");
    try {
      const res = await fetch("https://teamo.co.za/api/users/delete-account", {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        alert("Your account has been deleted.");
        localStorage.removeItem("authToken");
        navigate("/login");
      } else {
        const data = await res.json();
        alert(`Account deletion failed: ${data.error || res.statusText}`);
      }
    } catch (err) {
      console.error("Account deletion error:", err);
      alert("An error occurred while deleting your account.");
    }
  };

  if (!fullName) return null;

  return (
    <div
      ref={dropdownRef}
      className="userbadge-container"
    >
      <button className="userbadge-button" onClick={() => setIsOpen(!isOpen)}>
        👤 {fullName} ▼
      </button>

      {isOpen && (
        <div className="userbadge-dropdown">
          <button className="userbadge-dropdown-item" onClick={handleEditProfile}>
            ✏️ Edit Profile
          </button>
          <button className="userbadge-dropdown-item" onClick={handleChangePassword}>
            🔐 Change Password
          </button>
          <button className="userbadge-dropdown-item" onClick={handleLogout}>
            🚪 Logout
          </button>
          <button className="userbadge-dropdown-item" onClick={handleDeleteAccount}>
            🗑️ Delete Account
          </button>
        </div>
      )}
    </div>
  );
};

export default UserBadge;
